import { Logger } from "../../utils/Logger";

const CTRL_TAG = "AdminSiteServiceController";

function noop(action: string): void {
    Logger.debug(`${CTRL_TAG}.${action} (no-op)`);
}

function slugify(input: string): string {
    return input
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .replace(/-{2,}/g, "-");
}

function normalizeTextareaLines(el: HTMLTextAreaElement | null): void {
    if (!el) return;
    const lines = el.value
        .split(/\r\n|\r|\n/)
        .map((line) => line.trim())
        .filter(Boolean);
    el.value = lines.join("\n");
}

function initForm(): void {
    const form = document.querySelector<HTMLFormElement>('form[data-admin-ajax="1"]');
    if (!form) return;

    const titleInput = document.getElementById("svc-title") as HTMLInputElement | null;
    const slugInput = document.getElementById("svc-slug") as HTMLInputElement | null;
    const offeringsInput = document.getElementById("svc-offer") as HTMLTextAreaElement | null;

    let lastAutoSlug = slugInput?.value.trim() ?? "";

    titleInput?.addEventListener("input", () => {
        if (!slugInput) return;
        const currentSlug = slugInput.value.trim();
        const nextSlug = slugify(titleInput.value);
        if (nextSlug === "") return;
        if (currentSlug === "" || currentSlug === lastAutoSlug) {
            slugInput.value = nextSlug;
            lastAutoSlug = nextSlug;
        }
    });

    slugInput?.addEventListener("input", () => {
        lastAutoSlug = slugInput.value.trim();
    });

    form.addEventListener(
        "submit",
        () => {
            normalizeTextareaLines(offeringsInput);
        },
        true,
    );
}

export const AdminSiteServiceController = {
    index(): void {
        noop("index");
    },
    create(): void {
        initForm();
    },
    store(): void {
        noop("store");
    },
    edit(): void {
        initForm();
    },
    update(): void {
        noop("update");
    },
    destroy(): void {
        noop("destroy");
    },
};
